import '@babel/runtime/helpers/extends';
import 'react';
import '@emotion/react';
import SvgPauseIconSecondary from './svgs/PauseIconSecondary.js';
import SvgPauseIcon from './svgs/PauseIcon.js';
import { useIcon } from '../../shared-components/icon/index.js';

var pauseIcon = (props => useIcon(SvgPauseIcon, SvgPauseIconSecondary, props));

export { pauseIcon as default };
